import { createSlice } from '@reduxjs/toolkit';

export interface LoadingScreen {
    isLoading: boolean;
}

const initialState: LoadingScreen = {
    isLoading: false,
};

export const loadingSlide = createSlice({
    name: 'loading',
    initialState,
    reducers: {
        showLoadingScreen: (state) => {
            state.isLoading = true;
        },
        hideLoadingScreen(state) {
            state.isLoading = false
        },
    }
});

export const { showLoadingScreen, hideLoadingScreen } = loadingSlide.actions;

export default loadingSlide.reducer;
